/**
 * Configuration constants for the Custom Markup Extension
 */

export const EXTENSION_CONFIG = {
	EXTENSION_ID: "CustomMarkupExtension",
	EXTENSION_NAME: "Custom Markup Extension",
	VERSION: "1.0.0",
};

export const MARKER_CONFIG = {
	DEFAULT_SIZE: 30,
	OFFSET_Y: 20,
	MAX_MARKERS: 1000,
	ANIMATION_DURATION: 200,
	POSITION_TOLERANCE: 50, // pixels for on-screen detection
};

export const POSITIONING_CONFIG = {
	CAMERA_CHANGE_THROTTLE_2D: 16, // ms
	CAMERA_CHANGE_THROTTLE_3D: 16, // ms (60fps)
	ELEMENT_READY_MAX_ATTEMPTS: 50,
	ELEMENT_READY_TIMEOUT: 16, // ms between attempts
	FALLBACK_TIMEOUT: 100, // ms for selection-based positioning
};

export const CSS_CLASSES = {
	MARKER: "custom-marker",
	MARKER_APPEARING: "appearing",
	MARKER_ACTIVE: "custom-marker--active",
	MARKER_HOVERED: "custom-marker--hovered",
	CONTROLS: "markup-controls",
	CONTROL_BUTTON: "markup-button",
};

export const VIEWER_EVENTS = {
	SELECTION_CHANGED: window.Autodesk?.Viewing?.SELECTION_CHANGED_EVENT,
	CAMERA_CHANGE: window.Autodesk?.Viewing?.CAMERA_CHANGE_EVENT,
	EXPLODE_CHANGE: window.Autodesk?.Viewing?.EXPLODE_CHANGE_EVENT,
	ISOLATE: window.Autodesk?.Viewing?.ISOLATE_EVENT,
};

export const LOGGING_CONFIG = {
	ENABLED: true,
	PREFIX: "[CustomMarkupExtension]",
	LEVELS: {
		ERROR: "error",
		WARN: "warn",
		INFO: "info",
		DEBUG: "debug",
	},
};
